import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Globals } from 'src/shared/globals';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private httpService: HttpClient, private global: Globals) { }

  ContactUs(body: any): Observable<any> {
    const url = `${this.global.apiUrl}Contact/Us`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.httpService.post<any>(url, body, httpOptions).pipe(
      map(Response => {
        return Response;
      }));
  }


  ContactPropertyOwner(body: any): Observable<any> {
    const url = `${this.global.apiUrl}Contact/PropertyOwner`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.httpService.post<any>(url, body, httpOptions).pipe(
      map(Response => {
        return Response;
      }));
  }

}
